import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import GraphiQL from 'graphiql';
import fetch from 'isomorphic-fetch';
import '../node_modules/graphiql/graphiql.css'
import '../node_modules/animate.css/animate.min.css'


class App extends Component {

  constructor(props){
      super(props);
      this.graphQLFetcher=this.graphQLFetcher.bind(this);
  }


    graphQLFetcher = function(graphQLParams) {
      return fetch('https://api.graphloc.com/graphql', {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(graphQLParams),
      }).then(response => response.json());
    }

  render() {
    return (
      <div className="App">
        <div className="App-header">
          <img src={logo} className="App-logo animated bounceIn" alt="logo" />
          <h2 className="headline">GraphQL Geolocation</h2>
          <p className="phrase">Free. SSL supported. IPv6 supported.</p>
        </div>
        <p className="App-intro">
          Find a geolocation of an IP address including latitude, longitude, city, country, time zone and more...<br/><br/>
          Just hit <code className="code">api.graphloc.com</code> to submit requests over HTTP or HTTPS
        </p>
        <div className="Container"><GraphiQL fetcher={this.graphQLFetcher} query={"# Welcome to Graphloc geolocation API \n \n# Feel free to play around, here is an example: \n \n{\n  getLocation(ip: \"189.59.228.170\") {\n    country {\n      names {\n        en\n      }\n      geoname_id\n      iso_code\n    }\n    location {\n      latitude\n      longitude\n    }\n  }\n}\n"}  /></div>
        <div className="footer">
          <p>New to GraphQL? <a href="http://graphql.org/learn/">Check the docs</a></p>
          <p> Developed by <a href="https://github.com/geraldoramos">@geraldoramos</a> - Includes GeoLite2 data created by <a href="https://maxmind.com">Maxmind</a></p>
        </div>
    </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js